<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const text = props.text || 'Boton';
    const url = props.url || '#';
    const background = styleOrEmpty(props.backgroundColor, 'background');
    const color = styleOrEmpty(props.textColor, 'color');
    const padding = styleOrEmpty(props.padding, 'padding');
    const radius = styleOrEmpty(props.borderRadius, 'border-radius');
    const fontSize = styleOrEmpty(props.fontSize, 'font-size');
    const fontFamily = styleOrEmpty(props.fontFamily, 'font-family');
    const align = props.align || 'left';
    const style = `${background}${color}${padding}${radius}${fontSize}${fontFamily}text-decoration:none;display:inline-block;`;
    return `<div style="text-align:${align};"><a href="${url}" style="${style}">${text}</a></div>`;
};

export default {
    name: 'MailingBlockButton',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
